import { ConversationRouterLayout } from "@spa/app/layouts/ConversationRouterLayout";
import { withSuspense } from "@spa/app/routes/withSuspense";
import type { RouteObject } from "react-router-dom";

const ChatPage = withSuspense(
  () => import("@dust-tt/front/components/pages/chats/ChatPage"),
  "ChatPage"
);

const ChatsLandingPage = withSuspense(
  () => import("@dust-tt/front/components/pages/chats/ChatsLandingPage"),
  "ChatsLandingPage"
);

export const chatsRoutes: RouteObject[] = [
  {
    path: "chats",
    element: <ConversationRouterLayout />,
    children: [
      { index: true, element: <ChatsLandingPage /> },
      { path: ":chatId", element: <ChatPage /> },
    ],
  },
];
